import {
    CForm,
    CFormFeedback,
    CFormLabel, CFormSelect,
    CLoadingButton, CModal,
    CModalBody,
    CModalHeader,
    CModalTitle
} from "@coreui/react-pro";
import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useAddTraineeToTrainer, useGetAllTrainers} from "../../hooks/admin/adminApiHooks";
import ShowLoading from "../ShowLoading";
import {fail_notify, success_notify} from "../../constant";
import {AddTraineeToTrainerSchema} from "../../form-schema/admin-form-schema/addTraineeToCohortSchema";
import {useAppContext} from "../../context/user/UserAppProvider";

const TraineeToTrainerModal = ({visible, setVisible, applicantId}) => {

    const {header} = useAppContext()

    const {
        data: trainersData,
        isLoading: isTrainersLoading,
    } = useGetAllTrainers()
    const {mutate, isLoading, isSuccess, isError, error} = useAddTraineeToTrainer()

    useEffect(() => {
        if (isSuccess) {
            success_notify('Successfully created')
            setVisible(false)
        }
        if (isError) {
            fail_notify(error?.response?.data?.message)
        }
    }, [isError, error, isSuccess])

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm({
        resolver: yupResolver(AddTraineeToTrainerSchema),
    })

    if (isTrainersLoading) {
        return <ShowLoading/>
    }

    const handleAddApplicant = (data) => {
        data.applicantId = applicantId
        mutate({data, header})
    }

    return (
        <CModal
            backdrop="static"
            visible={visible}
            onClose={() => {
                setVisible(false)
            }}
        >
            <CModalHeader onClose={() => setVisible(false)}>
                <CModalTitle id="">Assign Trainee To Trainer</CModalTitle>
            </CModalHeader>
            <CModalBody>
                {(isTrainersLoading) ? <ShowLoading/> :
                    <div className="d-flex flex-column justify-content-center">
                        <p className="mt-1 mb-4">Select Trainer for Trainee.</p>
                        <CForm className="w-100" onSubmit={handleSubmit(handleAddApplicant)}>
                            <div>
                                <CFormLabel className="m-0 mb-1">Trainer</CFormLabel>
                                <CFormSelect
                                    className="m-0 mb-3"
                                    {...register('instructorId')}
                                    invalid={!!errors?.instructorId}
                                >
                                    <option default value={null}>Select</option>
                                    {trainersData?.data?.data?.items?.map(({id, firstName, lastName}, index) => {
                                        return <option key={index} value={id}>{firstName} {lastName}</option>
                                    })}
                                </CFormSelect>
                                <CFormFeedback invalid={!!errors?.instructorId}>
                                    {errors?.instructorId?.message}
                                </CFormFeedback>
                            </div>
                            <div className="d-flex justify-content-end">
                                <CLoadingButton
                                    loading={isLoading}
                                    disabled={isLoading}
                                    color="primary"
                                    type="submit"
                                    className="text-white my-3 px-5"
                                >
                                    Submit
                                </CLoadingButton>
                            </div>
                        </CForm>
                    </div>
                }
            </CModalBody>
        </CModal>
    )
}

export default TraineeToTrainerModal